import Entity from "./entity";
import Member from "./member";
import Objective from "./objective";
import Project from "./project";
import GoalMember from "./goal-member";
import GoalTeam from "./goal-team";

export default class Goal extends Entity<string> {
  name: string;
  startDate: string;
  endDate: string;
  teamworkOption: number;
  calculationOption: number;
  gradingOption: number;
  gradeModel: string;
  content: string;
  contentVersion: string;
  hashTags: string;
  completed: boolean;
  archived: boolean;
  ownerId: number;
  owner: Member;
  description: string;
  trackingResult: number;
  selfAverageResult: number;
  otherAverageResult: number;
  averageResult: number;
  userTrackingResults: number[];
  objectives: Objective[];
  members: GoalMember[];
  teams: GoalTeam[];
  grantedPermissions;
}
